module.exports = __webpack_public_path__ + "img/6.639bc8ae.jpg";